import { createContext } from 'react';

export const GymContext = createContext({
  gyms: [],
  gym: {},
  gymTypes: [],
  types: [],
  organizations: [],
  provinces: [],
  cities: [],
});
